export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-lightbulb-line',
      title: 'DX戦略設計',
      description: '経営課題を可視化し、一過性ではない「勝てるロードマップ」を策定。',
    },
    {
      number: '2',
      icon: 'ri-team-line',
      title: '伴走型実行支援',
      description: 'ECとSNSを統合し、実務を回しながら現場のスキルを引き上げる。',
    },
    {
      number: '3',
      icon: 'ri-graduation-cap-line',
      title: 'e-learning研修',
      description: 'リテラシー教育を通じて、社内に「自力で動ける人材」を育成。',
    },
  ];

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-10 sm:mb-14 md:mb-18">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#333333] mb-4 sm:mb-5">
            戦略から実行まで、一気通貫で支援
          </h2>
          <p className="text-[0.8rem] sm:text-sm md:text-base text-[#333333] leading-[1.8] max-w-3xl mx-auto">
            Naturiは、「提案だけ」のコンサルティングではありません。貴社の経営課題に対して、戦略を立てるだけでなく、実際に手を動かして実行し、成果が出るまで伴走します。
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 p-4 sm:p-6 space-y-4 hover:border-[#27ae60] transition-all"
            >
              <div className="flex justify-center">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#27ae60]">
                  <span className="text-xl sm:text-2xl text-white">{step.number}</span>
                </div>
              </div>

              <div className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-[#e8f5e9] mx-auto rounded-full">
                <i className={`${step.icon} text-lg sm:text-xl text-[#27ae60]`}></i>
              </div>

              <h3 className="text-base sm:text-lg text-[#333333] text-center">{step.title}</h3>

              <p className="text-[0.8rem] sm:text-sm md:text-base text-[#333333] leading-[1.7] text-center">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
